export default {
  title: 'Seyahatlerim',
  noTrips: 'Yaklaşan Seyahat Yok',
  noTripsDescription: 'Şu anda planlanmış seyahatiniz bulunmamaktadır.',
  whereTo: 'Nereye?',
  cancel: 'Seyahati İptal Et',
  cancelSuccess: 'Seyahat başarıyla iptal edildi',
  cancelError: 'Seyahat iptal edilemedi',
  loadError: 'Seyahat verileri yüklenemedi',

  // Status labels
  now: 'Şimdi',
  active: 'Aktif',
  requested: 'Talep Edildi',
  reserved: 'Rezerve Edildi',
  notUsing: 'Kullanılmıyor',
  regular: 'Normal',
  waitlisted: 'Bekleme Listesi',

  // Direction labels
  from: 'Nereden',
  to: 'Nereye',
  departure: 'Kalkış',
  arrival: 'Varış',
  etd: 'TKS',
  eta: 'TVS',
  fromDeparture: 'Kalkış Yönü',
  toArrival: 'Varış Yönü',

  // Location labels
  campus: 'Kampüs',
  stopToBeAssigned: 'Durak atanacak',

  // Capacity summary labels (tekil | çoğul, $tc() ile kullanılır)
  rider: '1 yolcu | {count} yolcu',
  bike: '1 bisiklet | {count} bisiklet',
  wheelchair: '1 tekerlekli sandalye | {count} tekerlekli sandalye',

  // Kapasite bilgisiyle birlikte durum cümleleri
  requestedWithCapacity: '{capacity} için talep oluşturuldu.',
  reservedWithCapacity: '{capacity} için rezervasyon yapıldı.',

  // Vehicle and driver labels
  vehicle: 'Araç',
  driver: 'Sürücü',

  // Alert confirmations
  cancelRequest: 'Talebi İptal Et',
  areYouSureToCancel: 'Talebinizi iptal etmek istediğinizden emin misiniz?',
  continue: 'Devam Et',

  deleteReservation: 'Rezervasyonu Sil',
  deleteReservationSingleDayMessage:
    '<b>{0}</b> güzergahına ait <b>{1}</b> tarihli, {2} yönündeki <b>{3}</b> saatli rezervasyonunuzu silmek istediğinizden emin misiniz?',
  deleteReservationMultiDayMessage:
    '<b>{0}</b> güzergahına ait <b>{1}</b> tarihli, {2} yönündeki <b>{3}</b> saatli rezervasyonunuzu silmek istediğinizden emin misiniz? Bu çok günlü bir rezervasyondur. Yalnızca seçili seyahati mi yoksa bu rezervasyondaki tüm günleri mi silmek istiyorsunuz?',
  deleteThisTripOnly: 'Yalnızca Bu Seyahati Sil',
  deleteAllDays: 'Tüm Günleri Sil',
  deleteAllReservationsConfirmMessage: 'Lütfen bu güzergahtaki TÜM rezervasyonları silmek istediğinizi onaylayın.',
  delete: 'Sil',

  // Waitlist dialog
  removeFromWaitlistTitle: 'Bekleme Listesinden Çık?',
  leaveWaitlist: 'Bekleme Listesinden Çık',
  keepMySpot: 'Sıramı Koru',
  areYouSureToLeaveWaitlist: 'Eğer <b>{0}</b> bekleme listesinden çıkarsanız sıranız boşa çıkacaktır.',

  // Unsubscribe dialog
  stopTracking: 'Takibi Bırak',
  stopTrackingMessage: '<b>{0}</b> güzergahının takibini bırakmak istediğinizden emin misiniz?',

  // Change usage dialog
  confirmAbsence: 'Yokluğu Onayla',
  confirmAttendance: 'Katılımı Onayla',
  notAttendingMessage:
    '<b>{0}</b> güzergahına {1} <b>{2}</b> durağından, <b>{3}</b> tarihinde katılmayacağınızı onaylayın. Birden fazla gün katılmayacaksanız tarihleri düzenleyebilirsiniz.',
  attendingMessage:
    '<b>{0}</b> güzergahına {1} <b>{2}</b> durağından, <b>{3}</b> tarihinde katılacağınızı onaylayın. Birden fazla gün katılacaksanız tarihleri düzenleyebilirsiniz.',
  confirm: 'Onayla',
  editDates: 'Tarihleri Düzenle',
  editDatesMessage: 'Bu değişikliğin uygulanmasını istediğiniz tarih aralığını seçin.',
  editDatesStartRequired: 'Lütfen başlangıç tarihi seçin.',
  editDatesEndInvalid: 'Bitiş tarihi başlangıç tarihinden önce olamaz.',
  optOutFromShuttle: 'Servisten Çık',
  optOutFromVanpool: 'Vanpool’dan Çık',
  optOutMessageShuttle: 'Bu servis güzergahından çıkmak istediğinizden emin misiniz?',
  optOutMessageVanpool: 'Bu vanpool güzergahından çıkmak istediğinizden emin misiniz?',
  optOutConfirm: 'Çık',
  optOutSuccessMessage: '<b>{0}</b> güzergahından çıktınız.',
};
